export default __webpack_public_path__ + "static/media/md8-quality.4bd4037d.svg";